<template>
  <div>
    <v-progress-circular v-if="isLoading && !hideProgress" indeterminate color="loader" />
    <file-input
        v-if="!isLoading"
        :color="color"
        :icon="icon"
        :tip="$t(tip)"
        :accept="accept"
        :disabled="disabled"
        @change="uploadBusinessFile" />
  </div>
</template>

<script>
  import FileInput from './FileInput.vue'
  export default {
    components: {
      FileInput
    },
    props: {
      documentType: {
        type: String,
        required: true
      },
      documentGroup: {
        type: String,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      uploadMethod: {
        type: [Function, Promise],
        default: () => { }
      },
      color: {
        type: String,
        default: 'addbtn'
      },
      icon: {
        type: String,
        default: 'add'
      },
      hideProgress: {
        type: Boolean,
        default: false
      },
      tip: {
        type: String,
        default: 'Загрузить файл'
      }
    },
    data () {
      return {
        accept: '.xls,.xlt,.xla,.xlsx,.xltx,.xlsm,.xltm,.xlam,.xlsb,.doc,.dot,.docx,.dotx,.docm,.dotm,.pdf,.tif,.tiff,.jpeg,.jpg,.bmp,.png,.csv,.sig,.xml,.rar,.zip,.7z,.txt',
        isLoading: false
      }
    },
    methods: {
      uploadBusinessFile: async function (file) {
        if (!file) {
          return
        }
        const form = new FormData()
        form.append('documentType', this.documentType)
        form.append('documentGroup', this.documentGroup)
        form.append('file', file.file, file.name)
        if (!this.uploadMethod) {
          return
        }
        this.isLoading = true
        try {
          await this.uploadMethod(form, this.documentType, this.documentGroup)
          this.isLoading = false
          this.$emit('input', file.name)
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
